import React, { useEffect } from 'react';
import { StickyTopBar } from './components/StickyTopBar';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { BeforeAfterSection } from './components/BeforeAfterSection';
import { TransformationSection } from './components/TransformationSection';
import { ProductBreakdown } from './components/ProductBreakdown';
import { ValueStack } from './components/ValueStack';
import { OfferSection } from './components/OfferSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { Testimonials } from './components/Testimonials';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { MetaPixel } from './components/MetaPixel';
import { SocialProofPopup } from './components/ui/SocialProofPopup';
export function App() {
  useEffect(() => {
    document.title = 'Nutrición Canina Fácil';
  }, []);
  return <div className="min-h-screen bg-cream font-sans selection:bg-primary selection:text-white" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <StickyTopBar data-id="element-2" />
      <main data-id="element-3">
        <HeroSection data-id="element-4" />
        <ProblemSection data-id="element-5" />

        <BeforeAfterSection data-id="element-6" />
        <TransformationSection data-id="element-7" />
        <ProductBreakdown data-id="element-8" />
        <OfferSection data-id="element-9" />
        <ValueStack data-id="element-10" />
        <GuaranteeSection data-id="element-11" />
        <Testimonials data-id="element-12" />
        <FAQ data-id="element-13" />
        <FinalCTA data-id="element-14" />
      </main>

      {/* Simple Footer */}
      <footer className="bg-charcoal text-white/60 py-8 text-center text-sm" data-id="element-15">
        <div className="max-w-7xl mx-auto px-4" data-id="element-16">
          <p data-id="element-17">
            © {new Date().getFullYear()} Nutrición Canina Fácil. Todos los
            derechos reservados.
          </p>
          <p className="mt-2 text-xs text-white/40" data-id="element-18">
            Este sitio no es parte del sitio web de Facebook o Facebook Inc.
            Además, este sitio NO está respaldado por Facebook de ninguna
            manera. FACEBOOK es una marca registrada de FACEBOOK, Inc.
          </p>
        </div>
      </footer>

      <SocialProofPopup data-id="element-19" />
    </div>;
}